import * as types from './types';

const INITIAL_STATE = {
  getAllSiteItems: {
    loading: false,
    data: [],
    errors: null,
  },
  getParItems: {
    loading: false,
    data: null,
    errors: null,
  },
  postSaveOrder: {
    loading: false,
    data: null,
    errors: null,
  },
  getOrderDetails: {
    loading: false,
    data: null,
    errors: null,
  },
  getOrderTypes: {
    loading: false,
    data: [],
    errors: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CREATEEDITORDER_GETALLSITEITEMS_LOADING: {
      const { getAllSiteItems } = state;
      return {
        ...state,
        getAllSiteItems: { ...getAllSiteItems, loading: action.payload },
      };
    }
    case types.CREATEEDITORDER_GETALLSITEITEMS_SUCCESS: {
      const { getAllSiteItems } = state;
      return {
        ...state,
        getAllSiteItems: { ...getAllSiteItems, data: action.payload },
      };
    }
    case types.CREATEEDITORDER_GETALLSITEITEMS_ERROR: {
      const { getAllSiteItems } = state;
      return {
        ...state,
        getAllSiteItems: { ...getAllSiteItems, errors: action.payload },
      };
    }

    case types.CREATEEDITORDER_GETPARITEMS_LOADING: {
      const { getParItems } = state;
      return {
        ...state,
        getParItems: { ...getParItems, loading: action.payload },
      };
    }
    case types.CREATEEDITORDER_GETPARITEMS_SUCCESS: {
      const { getParItems } = state;
      return {
        ...state,
        getParItems: { ...getParItems, data: action.payload },
      };
    }
    case types.CREATEEDITORDER_GETPARITEMS_ERROR: {
      const { getParItems } = state;
      return {
        ...state,
        getParItems: { ...getParItems, errors: action.payload },
      };
    }

    case types.CREATEEDITORDER_POSTSAVEORDER_LOADING: {
      const { postSaveOrder } = state;
      return {
        ...state,
        postSaveOrder: { ...postSaveOrder, loading: action.payload },
      };
    }
    case types.CREATEEDITORDER_POSTSAVEORDER_SUCCESS: {
      const { postSaveOrder } = state;
      return {
        ...state,
        postSaveOrder: { ...postSaveOrder, data: action.payload },
      };
    }
    case types.CREATEEDITORDER_POSTSAVEORDER_ERROR: {
      const { postSaveOrder } = state;
      return {
        ...state,
        postSaveOrder: { ...postSaveOrder, errors: action.payload },
      };
    }

    case types.CREATEEDITORDER_GETORDERDETAILS_LOADING: {
      const { getOrderDetails } = state;
      return {
        ...state,
        getOrderDetails: { ...getOrderDetails, loading: action.payload },
      };
    }
    case types.CREATEEDITORDER_GETORDERDETAILS_SUCCESS: {
      const { getOrderDetails } = state;
      return {
        ...state,
        getOrderDetails: { ...getOrderDetails, data: action.payload },
      };
    }
    case types.CREATEEDITORDER_GETORDERDETAILS_ERROR: {
      const { getOrderDetails } = state;
      return {
        ...state,
        getOrderDetails: { ...getOrderDetails, errors: action.payload },
      };
    }

    case types.CREATEEDITORDER_GETORDERTYPES_LOADING: {
      const { getOrderTypes } = state;
      return {
        ...state,
        getOrderTypes: { ...getOrderTypes, loading: action.payload },
      };
    }
    case types.CREATEEDITORDER_GETORDERTYPES_SUCCESS: {
      const { getOrderTypes } = state;
      return {
        ...state,
        getOrderTypes: { ...getOrderTypes, data: action.payload },
      };
    }
    case types.CREATEEDITORDER_GETORDERTYPES_ERROR: {
      const { getOrderTypes } = state;
      return {
        ...state,
        getOrderTypes: { ...getOrderTypes, errors: action.payload },
      };
    }

    case types.CREATEEDITORDER_ADDORDERTYPE: {
      const { getOrderTypes } = state;
      const data = [...getOrderTypes.data];

      const oldOrderType = data.find(
        orderType => orderType.Description === action.payload
      );

      if (!oldOrderType) {
        data.push({ Id: action.payload, Description: action.payload });
      }

      return {
        ...state,
        getOrderTypes: { ...getOrderTypes, data },
      };
    }

    case types.CREATEEDITORDER_CLEARALL: {
      return INITIAL_STATE;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/state/createEditOrder/reducer.js